/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PnoCompositionData } from './PnoCompositionData';
import {
    PnoCompositionDataFromJSON,
    PnoCompositionDataFromJSONTyped,
    PnoCompositionDataToJSON,
    PnoCompositionDataToJSONTyped,
} from './PnoCompositionData';
import type { CampaignNumberGraphData } from './CampaignNumberGraphData';
import {
    CampaignNumberGraphDataFromJSON,
    CampaignNumberGraphDataFromJSONTyped,
    CampaignNumberGraphDataToJSON,
    CampaignNumberGraphDataToJSONTyped,
} from './CampaignNumberGraphData';
import type { MarketingChannelOverviewCollectionData } from './MarketingChannelOverviewCollectionData';
import {
    MarketingChannelOverviewCollectionDataFromJSON,
    MarketingChannelOverviewCollectionDataFromJSONTyped,
    MarketingChannelOverviewCollectionDataToJSON,
    MarketingChannelOverviewCollectionDataToJSONTyped,
} from './MarketingChannelOverviewCollectionData';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface LegacyCampaignPerformanceCompositionData
 */
export interface LegacyCampaignPerformanceCompositionData {
    /**
     * 
     * @type {CampaignNumberGraphData}
     * @memberof LegacyCampaignPerformanceCompositionData
     */
    pno?: CampaignNumberGraphData;
    /**
     * 
     * @type {CampaignNumberGraphData}
     * @memberof LegacyCampaignPerformanceCompositionData
     */
    orders?: CampaignNumberGraphData;
    /**
     * 
     * @type {PnoCompositionData}
     * @memberof LegacyCampaignPerformanceCompositionData
     */
    summary?: PnoCompositionData;
    /**
     * 
     * @type {MarketingChannelOverviewCollectionData}
     * @memberof LegacyCampaignPerformanceCompositionData
     */
    channels?: MarketingChannelOverviewCollectionData;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof LegacyCampaignPerformanceCompositionData
     */
    snapshot?: PrecalculationSnapshotReadMetadata;
}

/**
 * Check if a given object implements the LegacyCampaignPerformanceCompositionData interface.
 */
export function instanceOfLegacyCampaignPerformanceCompositionData(value: object): value is LegacyCampaignPerformanceCompositionData {
    return true;
}

export function LegacyCampaignPerformanceCompositionDataFromJSON(json: any): LegacyCampaignPerformanceCompositionData {
    return LegacyCampaignPerformanceCompositionDataFromJSONTyped(json, false);
}

export function LegacyCampaignPerformanceCompositionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegacyCampaignPerformanceCompositionData {
    if (json == null) {
        return json;
    }
    return {
        
        'pno': json['pno'] == null ? undefined : CampaignNumberGraphDataFromJSON(json['pno']),
        'orders': json['orders'] == null ? undefined : CampaignNumberGraphDataFromJSON(json['orders']),
        'summary': json['summary'] == null ? undefined : PnoCompositionDataFromJSON(json['summary']),
        'channels': json['channels'] == null ? undefined : MarketingChannelOverviewCollectionDataFromJSON(json['channels']),
        'snapshot': json['snapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['snapshot']),
    };
}

export function LegacyCampaignPerformanceCompositionDataToJSON(json: any): LegacyCampaignPerformanceCompositionData {
    return LegacyCampaignPerformanceCompositionDataToJSONTyped(json, false);
}

export function LegacyCampaignPerformanceCompositionDataToJSONTyped(value?: LegacyCampaignPerformanceCompositionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pno': CampaignNumberGraphDataToJSON(value['pno']),
        'orders': CampaignNumberGraphDataToJSON(value['orders']),
        'summary': PnoCompositionDataToJSON(value['summary']),
        'channels': MarketingChannelOverviewCollectionDataToJSON(value['channels']),
        'snapshot': PrecalculationSnapshotReadMetadataToJSON(value['snapshot']),
    };
}

